import Vue from 'vue'
import Vuex from 'vuex'
import VuexEasyFirestore from 'vuex-easy-firestore'
import { Firebase } from '@/service/firebase'

import AssociationsModule from '@/store/associations'
import CommentsModule from '@/store/comments'
import GlobalModule from '@/store/global'
import ImagesModule from '@/store/images'
import UsersModule from '@/store/users'

Vue.use( Vuex )

const firestoreService = VuexEasyFirestore(
    [
        AssociationsModule,
        CommentsModule,
        ImagesModule,
        UsersModule
    ],
    { logging: true, FirebaseDependency: Firebase }
)

export const store = new Vuex.Store( {
    modules: {
        globalModule: GlobalModule
    },
    plugins: [firestoreService]
} )